import React, { useState } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Card, CardBody, CardTitle, Modal,
} from 'reactstrap';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import { Can } from '../../utilities/Can';
import BaseGrid from '../../components/Common/BaseGrid';
import { post, del } from '../../helpers/api_helper';
import UserForm from '../../components/User/form';
import * as url from '../../helpers/url_helper';
import avatar from '../../assets/images/users/smile-64.png';

function Users(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [signal, setSignal] = useState(1);

  const launchCreate = () => {
    setCreateModalOpen(true);
  };

  async function resetPassword(row, e) {
    const btn = e.currentTarget;

    btn.disabled = true;
    btn.blur();
    btn.firstChild.classList.toggle('bx-spin');

    try {
      await post(url.POST_PASSWORD_RESET, {
        id: row.id,
        pin: '',
      });

      toastr.success(`Password reset for ${row.email}`, 'Success');
    } catch (error) {
      toastr.error(error.message, 'Error');
    } finally {
      btn.disabled = false;
      btn.firstChild.classList.toggle('bx-spin');
    }
  }

  async function deleteUser(user) {
    try {
      await del(`/api/user/${user.id}`);

      setSignal((prev) => prev + 1);
      toastr.success(`User ${user.email} deleted`, 'Success');
    } catch (error) {
      toastr.error(error.message, 'Error');
    }
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col xxl="10">
            <Card>
              <CardBody>
                <CardTitle className="h4">{props.t('Users')}</CardTitle>

                <Can i="see" this="Users">
                  <BaseGrid
                    url={url.GET_USERS}
                    hasSearch
                    shouldUpdate={signal}
                    create={launchCreate}
                    config={
                    {
                      columns: {
                        thumb: {
                          label: 'Avatar',
                          image: {
                            src: (item) => item.profile_image || avatar,
                            class: 'rounded',
                            style: { maxHeight: '3rem', maxWidth: '3rem' },
                          },
                          translate: false,
                        },
                        id: { label: 'ID', sort: true },
                        display_name: { label: 'Display Name' },
                        real_name: { label: 'Real Name', sort: true },
                        email: { label: 'Email Address', sort: true },
                        roles: {
                          label: 'Roles',
                          sort: false,
                          badges: {
                            class: 'bg-info bg-soft text-dark p-2',
                            split: ',',
                          },
                        },
                        actions: {
                          label: 'Actions',
                          actions: [
                            {
                              key: 'reset_pass',
                              icon: 'bx bx-reset',
                              class: 'btn btn-sm btn-soft-warning text-dark',
                              alt: 'Reset Pin',
                              click: resetPassword,
                            },
                            {
                              key: 'delete',
                              icon: 'bx bx-trash',
                              class: 'btn btn-sm btn-soft-danger',
                              alt: 'Delete',
                              click: deleteUser,
                            },
                          ],
                        },
                      },
                      pagination: {
                        sort: 'id',
                        direction: 'asc',
                        perPage: 30,
                      },
                    }
                    }
                  />
                </Can>

                <Can not i="see" this="Users"><p>{props.t('Unauthorized')}</p></Can>
              </CardBody>
            </Card>

            <Modal
              size="md"
              isOpen={createModalOpen}
            >
              <div className="modal-header">
                <h5
                  className="modal-title mt-0"
                >
                  {props.t('New User')}
                </h5>
                <button
                  onClick={() => { setCreateModalOpen(false); }}
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <UserForm actionUrl="/api/user/create" onSuccess={() => { setCreateModalOpen(false); }} />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  onClick={() => { setCreateModalOpen(false); }}
                  className="btn btn-soft-dark"
                  data-dismiss="modal"
                >
                  {props.t('Cancel')}
                </button>
                <button
                  type="submit"
                  form="UserForm"
                  className="btn btn-primary"
                >
                  {props.t('Create')}
                </button>
              </div>
            </Modal>
          </Col>
        </Row>
      </div>
    </div>
  );
}

Users.defaultProps = {
  t: (x) => (x),
};

Users.propTypes = {
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(Users));
